export default __webpack_public_path__ + "static/TrueAutomation-6c60cf8c555c37c43de042208888e866.mp4";